import { Injectable } from '@angular/core';
import { Command } from '../command/command';
import { CommandHandler } from '../command/command-handler';
import { State } from '../state';
import { AppState } from '../state.module';

import {
  AddCurrentWizzardStep,
  AddCustomerPhoneCommand,
  AddBrandToCustomerPhoneCommand,
  AddModelToCustomerPhoneCommand,
  AddCustomerTypeCommand,
  AddCustomerDetailsCommand,
  AddEstimationIdCommand,
  AddCustomerIdCommand,
  AddOrderIdCommand,
  AddEstimateCommand,
  AddPaymentIdCommand,
  AddPaymentCommand,
  AddInvoicePdfIdCommand
} from './order-commands';

@Injectable()
export class OrderCommandHandlerService implements CommandHandler {

  handle(state: State, command: Command): State {
    const appState = (state as AppState);

    switch (command.name) {
      case 'add_current_wizzard_step':
        const addCurrentWizzardStep = (command as AddCurrentWizzardStep);
        return appState.order.addCurrentWizzardStep(addCurrentWizzardStep.step);

      case 'add_customer_phone':
        const addCustomerPhoneCommand = (command as AddCustomerPhoneCommand);
        return appState.order.addCustomerPhone(addCustomerPhoneCommand.phone);

      case 'add_brand_to_customer_phone':
        const addBrandToCustomerPhoneCommand = (command as AddBrandToCustomerPhoneCommand);
        return appState.order.addBrandToCustomerPhone(addBrandToCustomerPhoneCommand.brand);

      case 'add_model_to_customer_phone':
        const addModelToCustomerPhoneCommand = (command as AddModelToCustomerPhoneCommand);
        return appState.order.addModelToCustomerPhone(addModelToCustomerPhoneCommand.model);

      case 'add_customer_type':
        const addCustomerTypeCommand = (command as AddCustomerTypeCommand);
        return appState.order.addCustomerType(addCustomerTypeCommand.type);

      case 'add_customer_details':
        const addCustomerDetailsCommand = (command as AddCustomerDetailsCommand);
        return appState.order.addCustomerDetails(addCustomerDetailsCommand.customer);

      case 'add_estimation_id':
        const addEstimationIdCommand = (command as AddEstimationIdCommand);
        return appState.order.addEstimationId(addEstimationIdCommand.id);

      case 'add_customer_id':
        const addCustomerIdCommand = (command as AddCustomerIdCommand);
        return appState.order.addCustomerId(addCustomerIdCommand.id);

      case 'add_order_id':
        const addOrderIdCommand = (command as AddOrderIdCommand);
        return appState.order.addOrderId(addOrderIdCommand.id);

      case 'add_estimate':
        const addEstimateCommand = (command as AddEstimateCommand);
        return appState.order.addEstimate(addEstimateCommand.estimate);

      case 'add_payment_id':
        const addPaymentIdCommand = (command as AddPaymentIdCommand);
        return appState.order.addPaymentId(addPaymentIdCommand.id);

      case 'add_payment':
        const addPaymentCommand = (command as AddPaymentCommand);
        return appState.order.addPayment(addPaymentCommand.payment);

      case 'add_invoice_pdf_id':
        const addInvoicePdfIdCommand = (command as AddInvoicePdfIdCommand);
        return appState.order.addinvoicePdfId(addInvoicePdfIdCommand.id);
    }

    throw new Error(`OrderCommandHandlerService cannot handle command ${command.name}".`);
  }
}



// WEBPACK FOOTER //
// ./src/app/state/order/order-command-handler.service.ts